try {
    window.axios = require('axios');
    window.digidos_kvk_selector_btn = require("../modules/kvk/kvk-button-selector");
    window.kvk_selector_full = require("../modules/kvk/kvk-full-selector");
} catch (e) {console.log(e)}
